var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
export const Checkbox = (_a) => {
    var { className, register, onChange } = _a, rest = __rest(_a, ["className", "register", "onChange"]);
    return (_jsx("input", Object.assign({}, rest, { className: cn(className), type: "checkbox" }, register, { onChange: (e) => {
            register.onChange(e);
            onChange === null || onChange === void 0 ? void 0 : onChange(e);
        } })));
};
